import React from 'react';
import { useSelector } from 'react-redux';
import { selectMatch } from '../../features/match/matchSlice';
import lodash from 'lodash';
import StyledScore from './StyledScore';
import { FormattedMessage } from 'react-intl';

const Score: React.FC = () => {
  const match = useSelector(selectMatch);
  const { homeTeam, awayTeam, result } = match;

  return (
    <StyledScore>
      <div className="mainScore">
        <div className="name">{homeTeam.name}</div>
        <div className="score">
          {!lodash.isNil(result?.homeScorePenalties) && result?.homeScorePenalties + ' - ' + result?.awayScorePenalties}
          {lodash.isNil(result?.homeScorePenalties) &&
            !lodash.isNil(result?.homeScore120) &&
            result?.homeScore120 + ' - ' + result?.awayScore120}
          {lodash.isNil(result?.homeScorePenalties) &&
            lodash.isNil(result?.homeScore120) &&
            !lodash.isNil(result?.homeScore90) &&
            result?.homeScore90 + ' - ' + result?.awayScore90}
          {lodash.isNil(result?.homeScore90) && ' - '}
        </div>
        <div className="name">{awayTeam.name}</div>
      </div>
      <div className="ordinaryScore">
        {(!lodash.isNil(result?.homeScore120) || !lodash.isNil(result?.homeScorePenalties)) && (
          <>
            <FormattedMessage id="score.ordinaryTime" />
            &nbsp;
            {result?.homeScore90} - {result?.awayScore90}
          </>
        )}
        {!lodash.isNil(result?.homeScorePenalties) && !lodash.isNil(result?.homeScore120) && (
          <>
            .&nbsp;
            <FormattedMessage id="score.aet" />
            &nbsp;
            {result?.homeScore120} - {result?.awayScore120}
          </>
        )}
      </div>
    </StyledScore>
  );
};

export default Score;
